BPromise = require "bluebird"
class DeviceCtrl
  @$inject: ["$rootScope", "$scope", "$window", "$state", "$stateParams", "deviceBulkAction","toasty", "editor", "selector", "Tag", "Device"]
  constructor: ($rootScope, $scope, $window, $state, $stateParams, deviceBulkAction, toasty, editor, selector, Tag, Device)->
    Device.get().$promise.then (result)=>    
      $scope.devices = result  
    $scope.controllerTitle = "Device Management"
    $scope.devicesAllSelected = false;
    $scope.filter = {}
    $scope.bulkAction = {
      isOpen: false,
      list: [{name: "Add Tag", action: "bulkAddTag"}, {name: "Bulk CSV Update", action: "bulkCsvUpdate"}]
    }
    if $stateParams.tag
      $scope.tag =
        _id: $stateParams.tag
    else
      $scope.tag = {}

    $scope.action = (action, selected)->
      $scope[action](selected)

    $scope.bulkCsvUpdate = (selected)->
      options = 
        model: "BulkCsvUpdate"
        title: "Bulk CSV Update"
        msg: "Please upload a valid csv file"
        windowClass: 'csv-update-window'
        backdrop: 'static'
        scope: $scope
      deviceBulkAction.open(options)
      .then (dirty)->
        if dirty
          $state.reload()
      , (event)->



    $scope.bulkAddTag = (selected)->
      options =
        model: "BulkAddTag"
        devices: selected
        title: "Add tag"
        msg: "Enter the tag below"
        backdrop: true
      deviceBulkAction
      .open(options)
        .then (tags)->
          newTagList = []
          BPromise.map tags,(tag)->
            if !tag._id
              newTag = new Tag()
              angular.copy(tag, newTag)
              newTag.$save()
                .then (result)->
                  for device in selected
                    device.$tag result
            else
              for device in selected
                device.$tag tag
          .then ()->
            $state.reload()

    
    $scope.upload = ($file)->
      Device.bulkCsvUpdate $file

    $scope.$watch "tag", (val)->
      if val
        $scope.filter.tags = val._id
      else
        $scope.filter.tags = null

    $scope.screenshot = (device)->
      $scope.device.$screenshot().then (data)->
        $scope.screenshot.data = data
    $scope.reboot = (device)->
      options =
        title: "Reboot Device"
        msg: "Confirm to reboot device?"
      warning.warn(options).then ()->
        $scope.device.$reboot()
    $scope.logcat = (device)->
      device.$logcat()
    $scope.refresh = (device)->
      device.$details().then (details)->
        $scope.details = details
    $scope.install = (device)->
      options =
        model: "Resource"
      if device.os is "ANDROID"
        options.filter =
          type: ["FOLDER", "APK"]
      else if device.os is "LINUX"
        options.filter =
          type: ["FOLDER", "CPK"]
      selector.select(options).then (resource)->
        device.$install(resource)
      .then ()->
        toasty.success
          title: 'Install Success'
          msg: "Install application success"
    $scope.remote = (device)->
      opt =
        _id: device._id
      $state.go("device-remote", opt)


    $scope.pull = (device)->
      options =
        source:
          path: null
        schema:
          path:
            type: "String"
            display: "Resource Path"
            required: true
      editor.edit(options).then (result)->
        device.$pull(result.path)
    $scope.secret = (device)->
      device.$secret().then ()->
        toasty.success
          title: 'Refresh Secret Success'
          msg: "Refresh Secret of #{device.name} success"
    $scope.edit = (device)->
      dirty = angular.copy(device)
      options =
        source: dirty
        schema:
          name:
            type: "String"
            display: "Device Name"
          order:
            type: "String"
            display: "Order No."
          serialno:
            type: "String"
            display: "Serial No."
          shipping:
            shippedAt:
              type: "Date"
              display: "Shipping Date"
          description:
            type: "Text"
            display: "Description"

      editor.edit(options).then (result)->
        result.$save()
      .then (result)->
        angular.copy(result, device)
        toasty.success
          title: 'Save Success'
          msg: "Save device information success"
    $scope.assign = (device)->
      opts =
        model: "Company"
        multi: true
        fields:[
          {value: "name", display: "Name"}
        ]

      selector.select(opts).then (companies)->
        companies.forEach (company)->
          device.$assign(company)
        toasty.success
          title: 'assign Device Success'
          msg: "Assign device #{device.name} success"
    details =
      html: "<a><i class='fa fa-info-circle'></i>Details</a>"
      enabled: -> true
      click: (scope) =>
        $window.open "devices/#{scope.device._id}",'_blank'
    edit =
      html: "<a><i class='fa fa-pencil-square-o'></i>Edit Info</a>"
      enabled: -> true
      click: (scope) =>
        {device} = scope
        $scope.edit device

    assign =
      html: '<a><i class="fa fa-share"></i>Assign</a>'
      enabled: -> true
      click: (scope) ->
        {device} = scope
        $scope.assign(device)
    terminal =
      html: '<a><i class="fa fa-terminal"></i>Terminal</a>'
      click: (scope) ->
        {device} = scope
        $state.go "devices.terminal", device
    $scope.menu = [details, edit, assign, terminal]

    $scope.deviceExist = (devices)->
      for device in devices
        if !device._id
          # console.log "no device"
          return false
        else
          return true

    $scope.checkDeviceAllChecked = (devices)->
      # console.log devices
      for device in devices
        if !device._id
          $scope.devicesAllSelected = false
          return $scope.devicesAllSelected
        if !device.$selected or device.$selected is false
          $scope.devicesAllSelected = false
          return $scope.devicesAllSelected
      $scope.devicesAllSelected = true
      return $scope.devicesAllSelected

    $scope.pressCheckAll = (devices)->
      if $scope.devicesAllSelected
        for device in devices
          device.$selected = false
      else
        for device in devices
          device.$selected = true

    $scope.test = ($dataset) -> 
      console.log $dataset
      # $scope.devicesAllSelected = !$scope.devicesAllSelected 
    


module.exports = DeviceCtrl




// WEBPACK FOOTER //
// ./src/component/device/controller.coffee